import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "countdown_measurement" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "countdown_label" }, "Hours", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_4 = { class: "countdown_measurement" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "countdown_label" }, "Minutes", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_7 = { class: "countdown_measurement" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "countdown_label" }, "Seconds", -1)
const _hoisted_9 = { class: "countdown_measurement" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "countdown_label" }, "Hours", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_12 = { class: "countdown_measurement" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "countdown_label" }, "Minutes", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_15 = { class: "countdown_measurement" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "countdown_label" }, "Seconds", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.countdownFinished)
    ? _renderSlot(_ctx.$slots, "finishedContent", { key: 0 }, () => [
        _createElementVNode("span", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(_toDisplayString(_ctx.difference.hours), 1)
        ]),
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(_toDisplayString(_ctx.difference.minutes), 1)
        ]),
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(_toDisplayString(_ctx.difference.seconds), 1)
        ])
      ])
    : (_ctx.difference !== undefined)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("span", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(_toDisplayString(_ctx.difference.hours), 1)
          ]),
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(_toDisplayString(_ctx.difference.minutes), 1)
          ]),
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, [
            _hoisted_16,
            _createTextVNode(_toDisplayString(_ctx.difference.seconds), 1)
          ])
        ], 64))
      : _createCommentVNode("", true)
}